import React from 'react';

function LabelResultadoDevolutiva({devolutiva}) {
    const {percentualGeral, classificacao} = devolutiva
    
    const colorStatus = {
        'AVANCADO': '#0DBABA',
        'BASICO' : '#CD5BE8',
        'INTERMEDIARIO': '#666BFD'
    }
    
    const style = {
        fontWeight: 'bold',
        color: colorStatus[classificacao],
        fontSize: '14px'
    }
    
    return (
        <p style={style}>{percentualGeral ? Math.ceil(percentualGeral): 0}</p>
    );
}

export default LabelResultadoDevolutiva;
